// The server decides what a photo is from its bytes, but a filename with a
// matching extension keeps downloads and logs honest — and a kept original may
// have no extension, or a wrong one, or the non-standard type image/jpg.
const EXT = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'image/heic': 'heic',
  'image/heif': 'heif',
};

export function photoExtension(contentType) {
  const type = String(contentType || '').toLowerCase().split(';')[0].trim();
  return EXT[type === 'image/jpg' ? 'image/jpeg' : type] || null;
}

// base name (extension stripped) + extension for the blob's type.
export function photoFilename(filename, contentType) {
  const base = (filename || 'photo').replace(/\.[^./\\]+$/, '') || 'photo';
  const ext = photoExtension(contentType);
  return ext ? `${base}.${ext}` : (filename || 'photo');
}
